import { render, staticRenderFns } from "./UcContractRentalCard.yaml?vue&type=template&id=a5cfc812&component"
import script from "./UcContractRentalCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractRentalCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports